export const SIZES = {
    SM: 'small',
    MD: 'medium',
    LG: 'large'
};

export const SIZE_MAP = {
    [SIZES.SM]: 16,
    [SIZES.MD]: 24,
    [SIZES.LG]: 32
};
